import { render, staticRenderFns } from "./WheelsetWheelMeasures.vue?vue&type=template&id=f68ada02&scoped=true"
import script from "./WheelsetWheelMeasures.vue?vue&type=script&lang=js"
export * from "./WheelsetWheelMeasures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f68ada02",
  null
  
)

export default component.exports